import classNames from 'classnames';
import {useMediaQuery} from 'hooks/useMediaQuery';
import {breakpoints} from 'lib/breakpoints';
import {CartProductItem} from 'modules/Cart/components/CartProductItem/CartProductItem';
import {useCartProducts} from 'modules/Cart/containers/CartProducts/useCartProducts';
import {FC} from 'react';

import {Checkbox, CheckboxSize} from 'components/Checkbox/Checkbox';

import styles from './CartProducts.module.css';

type Props = {
    className?: string;
};
export const CartProducts: FC<Props> = ({className}) => {
    const {
        products,
        isAllChecked,
        makeHandleChangeCount,
        makeHandleRemove,
        makeHandleRestore,
        makeHandleCheck,
        handleAllCheck,
    } = useCartProducts();

    const isMobile = useMediaQuery(breakpoints.down('sm'));

    if (!products?.length) {
        return null;
    }

    return (
        <div className={classNames(styles.block, className)}>
            <div className={styles.top}>
                <Checkbox
                    name="selectAll"
                    checked={isAllChecked}
                    onCheck={handleAllCheck}
                    label="Выбрать все"
                    size={isMobile ? CheckboxSize.L : CheckboxSize.S}
                />
            </div>
            <div className={styles.list}>
                {products.map((product) => (
                    <CartProductItem
                        key={product.id}
                        className={styles.product}
                        data={product}
                        onChangeCount={makeHandleChangeCount(product.id)}
                        onRemove={makeHandleRemove(product.id)}
                        onRestore={makeHandleRestore(product.id)}
                        onCheck={makeHandleCheck(product.id)}
                        amount={product.count}
                        removed={product.deleted}
                        checked={product.checked}
                    />
                ))}
            </div>
        </div>
    );
};
